export default __webpack_public_path__ + "static/MTHISISPROBABLYMOONSHINECANVASFLASK_600x600-1a464dd824505efd4d1934ab51af917d.png";